export const getWhatsAppUrl = (message) =>
  `https://wa.me/97471728679?text=${encodeURIComponent(message)}`;
